<template>
  <div class="container">
      <el-row :gutter="20">
          <el-col :span="6" class="listBorder">
              <span class="font_1">题目列表</span>
              <el-button type="info" plain @click="goBackToList">
                <el-icon><Fold /></el-icon>
                返回列表
              </el-button>
              <br>
              <el-row :gutter="20"  v-if="homeworkList">
                  <el-col :span="4" class="problemBorder" v-for="(homework, index) in homeworkList" :key="homework.homeworkId">
                      <el-progress type="circle" :percentage="100" :width="50" :color="(Problem && currentIndex == index) ? '#76EE00' : '#00BFFF'"  @click="choseProblem(index)">
                          <span class="percentage-value">{{ index + 1 }}</span>
                      </el-progress>
                  </el-col>
              </el-row>
          </el-col>


          <el-col :span="16" class="listBorder">
              <div v-if="Problem">
                  <span class="font_1">题目展示</span>
                  <div class="form-floating formStyle">
                      <span class="font_2">{{ currentIndex + 1 }}、题目内容（分值：{{ Problem.score }}）</span>
                      <p style="white-space: pre-line;" v-html="Problem.content"></p>
                  </div>

                  <!-- 填空题 -->
                  <div v-if="Problem.type == 1">
                      <div class="form-floating formStyle">
                          <input type="text" class="form-control" id="editFillValue" :value="Problem.problemRecord.answer" placeholder="name@example.com">
                          <label for="editFillValue">填空题答案</label>
                      </div>
                  </div>

                  <!-- 单选题 -->
                  <div v-if="Problem.type == 2">
                      <div class="input-group judgeStyle">
                          <div class="input-group-text">
                              A、
                              <input class="form-check-input mt-0" name="editSingleValue" type="radio" value="A" aria-label="Radio button for following text input" v-bind:checked="Problem.problemRecord.answer == 'A'">
                          </div>
                          <input type="text" class="form-control" id="editSingleValueA" :value="Problem.answerA" aria-label="Text input with radio button">
                      </div>
                      <div class="input-group judgeStyle">
                          <div class="input-group-text">
                              B、
                              <input class="form-check-input mt-0" name="editSingleValue" type="radio" value="B" aria-label="Radio button for following text input" v-bind:checked="Problem.problemRecord.answer == 'B'">
                          </div>
                          <input type="text" class="form-control" id="editSingleValueB" :value="Problem.answerB" aria-label="Text input with radio button">
                      </div>
                      <div class="input-group judgeStyle">
                          <div class="input-group-text">
                              C、
                              <input class="form-check-input mt-0" name="editSingleValue" type="radio" value="C" aria-label="Radio button for following text input"  v-bind:checked="Problem.problemRecord.answer == 'C'">
                          </div>
                          <input type="text" class="form-control" id="editSingleValueC" :value="Problem.answerC" aria-label="Text input with radio button">
                      </div>
                      <div class="input-group judgeStyle">
                          <div class="input-group-text">
                              D、
                              <input class="form-check-input mt-0" name="editSingleValue" type="radio" value="D" aria-label="Radio button for following text input"  v-bind:checked="Problem.problemRecord.answer == 'D'">
                          </div>
                          <input type="text" class="form-control" id="editSingleValueD" :value="Problem.answerD" aria-label="Text input with radio button">
                      </div>
                  </div>

                   <!-- 多选题 -->
                  <div v-if="Problem.type == 3">
                      <div class="input-group judgeStyle">
                          <div class="input-group-text">
                              A、<input class="form-check-input mt-0" name="editMultipleValue" type="checkbox" value="A" aria-label="Checkbox for following text input"   v-bind:checked="Problem.problemRecord.answer.includes('A')">
                          </div>
                          <input type="text" class="form-control" id="editMultipleValueA" :value="Problem.answerA"  aria-label="Text input with checkbox">
                      </div>
                      <div class="input-group judgeStyle">
                          <div class="input-group-text">
                              B、<input class="form-check-input mt-0" name="editMultipleValue" type="checkbox" value="B" aria-label="Checkbox for following text input"  v-bind:checked="Problem.problemRecord.answer.includes('B')">
                          </div>
                          <input type="text" class="form-control" id="editMultipleValueB" :value="Problem.answerB" aria-label="Text input with checkbox">
                      </div>
                      <div class="input-group judgeStyle">
                          <div class="input-group-text">
                              C、<input class="form-check-input mt-0" name="editMultipleValue" type="checkbox" value="C" aria-label="Checkbox for following text input"  v-bind:checked="Problem.problemRecord.answer.includes('C')">
                          </div>
                          <input type="text" class="form-control" id="editMultipleValueC" :value="Problem.answerC" aria-label="Text input with checkbox">
                      </div>
                      <div class="input-group judgeStyle">
                          <div class="input-group-text">
                              D、<input class="form-check-input mt-0" name="editMultipleValue" type="checkbox" value="D" aria-label="Checkbox for following text input"  v-bind:checked="Problem.problemRecord.answer.includes('D')">
                          </div>
                          <input type="text" class="form-control" id="editMultipleValueD" :value="Problem.answerD" aria-label="Text input with checkbox">
                      </div>
                  </div>

                  <!-- 判断题 -->
                  <div v-if="Problem.type == 4">
                      <div class="input-group judgeStyle">
                          <div class="input-group-text">
                              A、
                              <input class="form-check-input mt-0" name="editJudgeValue" type="radio" value="A" aria-label="Radio button for following text input"  v-bind:checked="Problem.problemRecord.answer == 'A'">
                          </div>
                          <input type="text" class="form-control" id="editJudgeValueA" :value="Problem.answerA" aria-label="Text input with radio button" >
                          <span class="displayStyle">————————</span>
                          <div class="input-group-text">
                              B、
                              <input class="form-check-input mt-0" name="editJudgeValue" type="radio" value="B" aria-label="Radio button for following text input"  v-bind:checked="Problem.problemRecord.answer == 'B'">
                          </div>
                          <input type="text" class="form-control" id="editJudgeValueB" :value="Problem.answerB" aria-label="Text input with radio button">
                      </div>
                  </div>

                  <!-- 简答题 -->
                  <div v-if="Problem.type == 5">
                      <div class="form-floating formStyle">
                          <textarea class="form-control" placeholder="Leave a comment here" id="editShortAnswer" :value="Problem.problemRecord.answer" ></textarea>
                          <label for="editShortAnswer">简答题答案</label>
                      </div>
                  </div>

                  <div class="form-floating formStyle">
                      <textarea class="form-control" placeholder="Leave a comment here" id="Answer" :value="Problem.rightAnswer"></textarea>
                      <label for="Answer">参考答案</label>
                  </div>

                  <div class="form-floating formStyle">
                        <input type="number" class="form-control" id="editScore" :value="Problem.problemRecord.score" placeholder="Password" min="0" :max="Problem.score">
                        <label for="editScore">得分</label>
                    </div>

                  <el-button type="primary" icon="Edit" class="btnStyle" @click="changeScore(Problem.problemRecord.recordId, Problem.problemRecord.userId, Problem.score)" plain>修改分值</el-button>
              </div>
          </el-col>
      </el-row>

              


</div>
</template>

<script setup>

import { ref, onMounted } from "vue";
import { ElMessage } from "element-plus";
import $ from "jquery";
import { useRoute } from "vue-router";


const courseId = ref();
const recordId = ref();

const Route = useRoute(); //获取到值
const Problem = ref();
const homeworkList = ref();
const currentIndex = ref(0);
const homeworkRecord = ref([]);

// 在组件初始化时获取路由参数并设置为 current_page
onMounted(() => {
// 获取路由参数并设置为 current_page
courseId.value = Route.params.courseId || '';
recordId.value = Route.params.recordId || '';
pullProblemList();
});

// 加载题目信息
const pullProblemList = () => {
const token = localStorage.getItem("token");
$.ajax({
  url: "http://124.222.105.205:5000/api/problem/getStuProblemRecord",
  data: {
    recordId: recordId.value,
  },
  type: "post",
  headers: {
    Authorization: "Bearer " + token,
  },
  success(resp) {
      if (resp.code == "200") {
          homeworkList.value = resp.data;
          console.log(homeworkList.value);
          Problem.value = homeworkList.value[currentIndex.value];
          for(let record of homeworkList.value) {
              homeworkRecord.value.push(record.problemRecord);
          }
          
      } else {
          ElMessage({
              type: "error",
              message: "拉取题目失败！"
          });
      }
  },
  error() {
      ElMessage({
          type: "error",
          message: "拉取题目失败！"
      });
  },
});
};

const changeScore = (rId, uId, maxScore) => {
  let score = $("#editScore").val();

  if (score < 0) {
    ElMessage({
          type: "error",
          message: "不能为负数"
      });
      return false;
  }


  if (score > maxScore) {
    ElMessage({
          type: "error",
          message: "不能超过最大分值"
      });
      return false;
  }

  const token = localStorage.getItem("token");
  $.ajax({
    url: "http://124.222.105.205:5000/api/problem/updateProblemRecordScore",
    data: {
      problemId: rId,
      userId: uId,
      examId: recordId.value,
      score: score
    },
    type: "post",
    headers: {
      Authorization: "Bearer " + token,
    },
    success(resp) {
        if (resp.code == "200") {
          ElMessage({
                type: "success",
                message: resp.msg
            });
          pullProblemList();
            
        } else {
            ElMessage({
                type: "error",
                message: resp.msg
            });
        }
    },
    error() {
        ElMessage({
            type: "error",
            message: "修改分数失败！"
        });
    },
  });
}


const choseProblem = (index) => {
  Problem.value = homeworkList.value[index];
  currentIndex.value = index;
}

const goBackToList = () => {
  window.history.back();
}

</script>

<style scoped>
.listBorder {
  background-color: rgb(247, 246, 246);
  border-radius: 20px;
  margin: 20px;
  height: 100%;
}

.percentage-value {
display: block;
font-size: 20px;
transition: 300ms;
}

.percentage-value:hover{
display: block;
font-size: 28px;
transition: 500ms;
}

.problemBorder {
  margin: 10px;
}

.problemBorder:hover{
  cursor: pointer;
  width: 40px;
}

.btnStyle {
  float: right;
  margin: 5px;
}

.font_1{
  font-size: 20px;
  font-weight: bold;
  color: rgb(112, 112, 112);
}
.font_2{
  font-size: 15px;
  font-weight: bold;
  color: rgb(112, 112, 112);
}

.formStyle {
  margin: 10px;
}

.judgeStyle {
  width: 800px;
  padding: 20px;
}

.displayStyle {
  color: rgba(240, 248, 255, 0);
}

</style>